
  const studentRequirement = {
    path: "/studentRequirement",
    name: "studentRequirement",
    component: () => import(/* webpackChunkName: "student_requirement" */ "@/components/studentRequirement/StudentRequirementIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "student_requirement" */ "@/components/studentRequirement/StudentRequirementView.vue"), name: "studentRequirementView" },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "student_requirement" */ "@/components/studentRequirement/StudentRequirementEdit.vue"), name: "studentRequirementEdit" },
      { path: "create", component: () => import(/* webpackChunkName: "student_requirement" */ "@/components/studentRequirement/StudentRequirementCreate.vue"), name: "studentRequirementCreate"}
    ],
    meta: { authorize: [], requiresAuth: true }
  };

export default studentRequirement;
    